/**
 *  @fileOverview GDPR Module, creates and shows GDPR Cookie banner and handles DMP code
 *
 *  @author       Aaron Chapman
 *
 */

function GDPRModule () {
  /**
   * @description Initiates GDPR Banner for correct users.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */

  this.init = function () {
    // Read Salesforce DMP audience profiles for user, either via localStorage or Cookies (older method)
    /* eslint-disable-next-line */
    window.Krux||((Krux=function(){Krux.q.push(arguments)}).q=[]),function(){function n(n){var r="kxedithcowan_"+n,u=function(){try{return window.localStorage}catch(n){return null}}();if(u)return u[r]||"";if(navigator.cookieEnabled){var e=document.cookie.match(r+"=([^;]*)");return e&&unescape(e[1])||""}return""}window.Krux.user=n("user"),window.Krux.segments=n("segs")?n("segs").split(","):[]}();

    // Build GDPR string
    let GDPRObject = '<div class="gdprBanner"><p>This site uses cookies. We use cookies to give you the best experience possible and for other purposes including analytics. By using our website, you agree to our use of cookies as described in the Cookies Notice. Click Accept to continue searching our website or find out more in our Cookies Notice.</p><a href="#" class="button gdprBanner__button">I accept</a></div>'

    // Check if user is in our GDPR audience. If in Europe and not in the accepted pool
    if (window.Krux.segments.indexOf('t6i8carw7') !== -1 && (window.Krux.segments.indexOf('t7it9g66t') === -1)) {
      document.body.prepend(GDPRObject)

      // Add event listener to watch for GDPR Accept Click
      let GDPRAccept = document.querySelector('.gdprBanner__button')
      GDPRAccept.addEventListener('click', acceptGDPR)
    }
  }

  let acceptGDPR = function (event) {
    event.preventDefault()

    // Add Krux Event
    /* eslint-disable-next-line */
    window.Krux || ((Krux = function () {
      /* eslint-disable-next-line */
      Krux.q.push(arguments)
    }).q = [])
    /* Krux('ns:edithcowan','admEvent', 'Mx5eX6-D', {event_type:'clk', Action:'YES'}); */
    /* eslint-disable-next-line */
    Krux('ns:edithcowan', 'admEvent', 'Mx5eX6-D', { Action: 'YES' })

    // Delete GDPR Banner from DOM
    let gdprBanner = document.querySelector('.gdprBanner')
    gdprBanner.parentNode.removeChild(gdprBanner)
  }
}

module.exports = GDPRModule
